// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

/* .alarm-history {
    width: 100%;
    padding: 20px;
    background-color: #f4f4f9;
    border-radius: 8px;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  } */

  .view-toggle{
    font-size: 20px;
  }
  .view-toggle label{
    margin-right: 20px;
  }
  .alarm-history h1 {
    text-align: center;
    margin-top: 25px;
    font-size: 24px;
    color: #333;
    font-weight: bold;
    letter-spacing: 1px;
  }
  
  .alarm-history table {
    width: 90%;
    border-collapse: collapse;
    margin-top: 30px;
    margin-left:75px;
    font-size: 16px;
    text-align: left;
  }
  
  .alarm-history thead {
    /* background-color: #45fb6c; */
    background-color: #28a745;
    color: white;
  }
  .alarm-history th{
    padding:6px;
    border: 1px solid #ddd;
  }
  
  .alarm-history td {
    padding: 8px;
    border: 1px solid #ddd;
  }
  
  .alarm-history tbody tr:nth-child(even) {
    background-color: #f9f9f9;
  }
  .alarm-id-cell{
    background-color: yellow;
  }
  .alarm-history tbody tr:hover {
    background-color: #f1f1f1;
    transition: background-color 0.2s ease;
  }
  
  .alarm-history th {
    font-weight: bold;
    /* text-transform: uppercase; */
    letter-spacing: 0.05em;
  }
  
  .alarm-history td {
    color: #555;
  }
  
  .alarm-history td:first-child {
    font-weight: bold;
  }
  
  .alarm-history__table-wrapper {
    max-height: 400px;
    overflow-y: auto;
    margin-top: 20px;
  }
  
  @media (max-width: 768px) {
    .alarm-history table, .alarm-history thead, .alarm-history tbody, .alarm-history th, .alarm-history td, .alarm-history tr {
      display: block;
    }
  
    .alarm-history tr {
      margin-bottom: 20px;
    }
  
    .alarm-history td {
      padding: 10px;
      text-align: right;
      position: relative;
    }
  
    .alarm-history td::before {
      content: attr(data-label);
      position: absolute;
      left: 0;
      padding-left: 10px;
      font-weight: bold;
      text-transform: uppercase;
      letter-spacing: 0.05em;
    }
  
    .alarm-history td:last-child {
      border-bottom: none;
    }
  }
  



  .pagination {
    display: flex;
    justify-content: center;
    margin-top: 20px;
  }
  
  .pagination button {
    padding: 10px;
    margin: 0 5px;
    background-color: #f1f1f1;
    border: 1px solid #ccc;
    cursor: pointer;
  }
  
  .pagination button.active {
    background-color: #007bff;
    color: white;
    border-color: #007bff;
  }
  
  .pagination button:disabled {
    background-color: #ddd;
    cursor: not-allowed;
  }
  `, "",{"version":3,"sources":["webpack://./src/components/AlarmManagement/AlarmHistory.css"],"names":[],"mappings":";;AAEA;;;;;;KAMK;;EAEH;IACE,eAAe;EACjB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,UAAU;IACV,yBAAyB;IACzB,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,+BAA+B;IAC/B,yBAAyB;IACzB,YAAY;EACd;EACA;IACE,WAAW;IACX,sBAAsB;EACxB;;EAEA;IACE,YAAY;IACZ,sBAAsB;EACxB;;EAEA;IACE,yBAAyB;EAC3B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;IACzB,sCAAsC;EACxC;;EAEA;IACE,iBAAiB;IACjB,+BAA+B;IAC/B,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE;MACE,cAAc;IAChB;;IAEA;MACE,mBAAmB;IACrB;;IAEA;MACE,aAAa;MACb,iBAAiB;MACjB,kBAAkB;IACpB;;IAEA;MACE,yBAAyB;MACzB,kBAAkB;MAClB,OAAO;MACP,kBAAkB;MAClB,iBAAiB;MACjB,yBAAyB;MACzB,sBAAsB;IACxB;;IAEA;MACE,mBAAmB;IACrB;EACF;;;;;EAKA;IACE,aAAa;IACb,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,aAAa;IACb,yBAAyB;IACzB,sBAAsB;IACtB,eAAe;EACjB;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,qBAAqB;EACvB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;EACrB","sourcesContent":["\r\n\r\n/* .alarm-history {\r\n    width: 100%;\r\n    padding: 20px;\r\n    background-color: #f4f4f9;\r\n    border-radius: 8px;\r\n    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);\r\n  } */\r\n\r\n  .view-toggle{\r\n    font-size: 20px;\r\n  }\r\n  .view-toggle label{\r\n    margin-right: 20px;\r\n  }\r\n  .alarm-history h1 {\r\n    text-align: center;\r\n    margin-top: 25px;\r\n    font-size: 24px;\r\n    color: #333;\r\n    font-weight: bold;\r\n    letter-spacing: 1px;\r\n  }\r\n  \r\n  .alarm-history table {\r\n    width: 90%;\r\n    border-collapse: collapse;\r\n    margin-top: 30px;\r\n    margin-left:75px;\r\n    font-size: 16px;\r\n    text-align: left;\r\n  }\r\n  \r\n  .alarm-history thead {\r\n    /* background-color: #45fb6c; */\r\n    background-color: #28a745;\r\n    color: white;\r\n  }\r\n  .alarm-history th{\r\n    padding:6px;\r\n    border: 1px solid #ddd;\r\n  }\r\n  \r\n  .alarm-history td {\r\n    padding: 8px;\r\n    border: 1px solid #ddd;\r\n  }\r\n  \r\n  .alarm-history tbody tr:nth-child(even) {\r\n    background-color: #f9f9f9;\r\n  }\r\n  .alarm-id-cell{\r\n    background-color: yellow;\r\n  }\r\n  .alarm-history tbody tr:hover {\r\n    background-color: #f1f1f1;\r\n    transition: background-color 0.2s ease;\r\n  }\r\n  \r\n  .alarm-history th {\r\n    font-weight: bold;\r\n    /* text-transform: uppercase; */\r\n    letter-spacing: 0.05em;\r\n  }\r\n  \r\n  .alarm-history td {\r\n    color: #555;\r\n  }\r\n  \r\n  .alarm-history td:first-child {\r\n    font-weight: bold;\r\n  }\r\n  \r\n  .alarm-history__table-wrapper {\r\n    max-height: 400px;\r\n    overflow-y: auto;\r\n    margin-top: 20px;\r\n  }\r\n  \r\n  @media (max-width: 768px) {\r\n    .alarm-history table, .alarm-history thead, .alarm-history tbody, .alarm-history th, .alarm-history td, .alarm-history tr {\r\n      display: block;\r\n    }\r\n  \r\n    .alarm-history tr {\r\n      margin-bottom: 20px;\r\n    }\r\n  \r\n    .alarm-history td {\r\n      padding: 10px;\r\n      text-align: right;\r\n      position: relative;\r\n    }\r\n  \r\n    .alarm-history td::before {\r\n      content: attr(data-label);\r\n      position: absolute;\r\n      left: 0;\r\n      padding-left: 10px;\r\n      font-weight: bold;\r\n      text-transform: uppercase;\r\n      letter-spacing: 0.05em;\r\n    }\r\n  \r\n    .alarm-history td:last-child {\r\n      border-bottom: none;\r\n    }\r\n  }\r\n  \r\n\r\n\r\n\r\n  .pagination {\r\n    display: flex;\r\n    justify-content: center;\r\n    margin-top: 20px;\r\n  }\r\n  \r\n  .pagination button {\r\n    padding: 10px;\r\n    margin: 0 5px;\r\n    background-color: #f1f1f1;\r\n    border: 1px solid #ccc;\r\n    cursor: pointer;\r\n  }\r\n  \r\n  .pagination button.active {\r\n    background-color: #007bff;\r\n    color: white;\r\n    border-color: #007bff;\r\n  }\r\n  \r\n  .pagination button:disabled {\r\n    background-color: #ddd;\r\n    cursor: not-allowed;\r\n  }\r\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
